import { TAG_NAME } from '../constants/TagNameConstants';

export const IMAGE_PATH_AND_NAME = {
  banner: {
    path: 'cover',
    name: 'list'
  },
  sameepisodelist: {
    path: 'list',
    name: 'list'
  },
  differentepisodelist: {
    path: 'list',
    name: 'list'
  },
  showDetail: {
    path: 'cover',
    name: 'list'
  },
  continueWatching: {
    path: 'portrait',
    name: 'cover'
  },
  episodes: {
    path: 'list',
    name: 'list'
  },
  listBig: {
    path: 'list',
    name: 'list'
  },
  liveNews: {
    path: 'list',
    name: 'list'
  },
  liveTitleBig: {
    path: 'list',
    name: 'list'
  },
  liveTitleSmall: {
    path: 'list',
    name: 'list'
  },
  playlistBig: {
    path: 'list',
    name: 'list'
  },
  playlistSmall: {
    path: 'list',
    name: 'list'
  },
  liveVodBig: {
    path: 'list',
    name: 'list'
  },
  liveVodSmall: {
    path: 'list',
    name: 'list'
  },
  portraitSmall: {
    path: 'portrait',
    name: 'cover'
  },
  top10: {
    path: 'portrait',
    name: 'cover'
  },
  portraitLarge: {
    path: 'portrait',
    name: 'cover'
  },
  title: {
    path: 'list',
    name: 'list'
  },
  collection: {
    path: 'square',
    name: 'list'
  },
  newsCollection: {
    path: 'list',
    name: 'list'
  },
  newsTitle: {
    path: 'list',
    name: 'list'
  },
  channels: {
    path: 'channel_list',
    name: 'list'
  },
  upcoming: {
    path: 'portrait',
    name: 'cover'
  },
  plexWidget: {
    path: 'list',
    name: 'list'
  },
  bellyUnitSingleCard: {
    path: 'list',
    name: 'list'
  },
  tvodCard: {
    path: 'portrait',
    name: 'cover'
  },
  comboPackBanner: {
    path: 'list',
    name: 'list'
  },
  portraitSmallBg: {
    path: 'portrait',
    name: 'portrait'
  },
  playerPoster: {
    path: 'list',
    name: 'list'
  },
  zee5Music: {
    path: 'homefeed_launcher_sticker',
    name: 'homefeed-launcher-sticker'
  },
  zee5MusicEntrypointBanner: {
    path: 'homefeed_launcher_sticker',
    name: 'homefeed-launcher-sticker'
  },
  mobileBanner: {
    path: 'mobileBanner',
    name: 'mobileBanner'
  },
  [TAG_NAME.SUBS_BANNER_PORTRAIT]: {
    path: 'portrait',
    name: 'portrait'
  },

  [TAG_NAME.SUBS_BANNER_LANDSCAPE]: {
    path: 'list',
    name: 'list'
  },
  [TAG_NAME.TOURNAMENT_TEAMS]: {
    path: 'cricket/ilt20/season1',
    name: 'portrait'
  }
};

const imagePathAndName: Readonly<typeof IMAGE_PATH_AND_NAME> =
  Object.freeze(IMAGE_PATH_AND_NAME);

export const getImagePathByTagName = (tagName: string) =>
  imagePathAndName[tagName as keyof typeof IMAGE_PATH_AND_NAME];
